import { useEffect, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import PhoneInput from 'react-phone-input-2';
import { ErrorMessage } from '@hookform/error-message';
import { useForm, Controller } from 'react-hook-form';
import FormInput from './FormInput';
import { updateChefDetails, addNewChef } from '../../../services/FoodItemsService';
import { objectToFormData } from '../../../utils/objectToFormData';
// images
import uploadImageIcon from '../../../images/upload_image.png';

const notify = (id, type, message, time) => {
    toast.update(id, {
        render: message,
        type: type,
        position: 'top-center',
        autoClose: time,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        isLoading: false,
    });
};

const AddChef = props => {
    const { addNewModal, setAddNewModal, chefDetails, chefId } = props;
    const uploadRef = useRef(null);
    const {
        handleSubmit,
        formState: { errors },
        register,
        setValue,
        control,
        watch,
        reset
    } = useForm({ mode: 'all' });
    const { ref, ...rest } = register('img');

    const watchImage = watch('img', null);

    useEffect(() => {
        if (chefId && chefDetails) {
            console.log(chefDetails)
            const fields = ['name', 'mobile', 'description', 'email', 'status'];
            fields.forEach(field => setValue(field, chefDetails[field]));
        }
    }, [setValue, chefId, chefDetails]);

    // Reset form when modal closes
    useEffect(() => {
        if (!addNewModal) {
            reset();
            if (uploadRef.current) {
                uploadRef.current.value = '';
            }
        }
    }, [addNewModal, reset]);

    const onSubmit = async data => {
        if (chefId && chefDetails) {
            const fields = ['name', 'mobile', 'description', 'email', 'status','img'];
            fields.forEach(field => {
                if (field === 'img' && (!data[field] || data[field].length < 1)) {
                    delete data[field];
                } else if (field === 'img' && data[field] && data[field].length > 0) {
                    data.img = data.img[0];
                }
                if (data[field] === undefined) {
                    delete data[field]
                }
            })
            let postData = objectToFormData(data, '')
            const toaster = toast.loading('Updating...');
            let res = await updateChefDetails(chefId, postData);
            if (res.status === 'success') {
                notify(toaster, 'success', 'Updated chef details!', 2000);
                setAddNewModal(false);
            } else {
                notify(toaster, 'error', res.data.message, 2000);
            }
        } else {
            const toaster = toast.loading('Creating...');
            if (data.img && data.img.length > 0) {
                data.img = data.img[0];
            }
            let postData = objectToFormData(data);
            let res = await addNewChef(postData);
            if (res.status === 'success') {
                notify(toaster, 'success', 'Added new chef details!', 2000);
                setAddNewModal(false);
            } else {
                notify(toaster, 'error', res.data.message, 2000);
            }
        }
    };

    // Function to handle image preview
    const getImageSrc = () => {
        if (watchImage && watchImage.length > 0 && uploadRef.current?.files?.length > 0) {
            return URL.createObjectURL(uploadRef.current.files[0]);
        }
        if (chefDetails?.img) {
            return process.env.REACT_APP_API_RESOURCE_URL + chefDetails.img;
        }
        return uploadImageIcon;
    };

    const hasImage = () => {
        return (watchImage && watchImage.length > 0) || chefDetails?.img;
    };

    if (chefId && !chefDetails) {
        return (
            <div id='preloader-inner'>
                <div className='sk-three-bounce-inner'>
                    <div className='sk-child sk-bounce1'></div>
                    <div className='sk-child sk-bounce2'></div>
                    <div className='sk-child sk-bounce3'></div>
                    <div id='preloader-inner-bg'></div>
                </div>
            </div>
        );
    } else {
        return (
            <Modal
                show={addNewModal}
                onHide={setAddNewModal}
                className='modal fade'
                id='addNewModal'
            >
                <>
                    <div className='modal-content'>
                        <div className='modal-header'>
                            <h5 className='modal-title'>{chefDetails && chefId ? 'Update Chef' : 'Add Chef'}</h5>
                            <button
                                type='button'
                                className='close'
                                data-dismiss='modal'
                                onClick={() => setAddNewModal(false)}
                            >
                                <span>×</span>
                            </button>
                        </div>
                        <div className='modal-body'>
                            <form
                                onSubmit={handleSubmit(onSubmit)}
                            >
                                <div className='food-image media mb-3'>
                                    {hasImage() ? (
                                        <>
                                            <button 
                                                type='button' 
                                                onClick={() => uploadRef.current?.click()}
                                                className='btn btn-primary food-image-edit'
                                            >
                                                <i className='flaticon-381-edit'></i>
                                            </button>
                                            <img
                                                className='mr-3 img-fluid rounded'
                                                src={getImageSrc()}
                                                alt='upload chef pic here'
                                                style={{ maxWidth: '150px', maxHeight: '150px', objectFit: 'cover' }}
                                            />
                                        </>
                                    ) : (
                                        <img
                                            className='mr-3 img-fluid rounded'
                                            onClick={() => uploadRef.current?.click()}
                                            style={{ width: '100px', cursor: 'pointer' }}
                                            src={uploadImageIcon}
                                            alt='upload chef pic here'
                                        />
                                    )}
                                    
                                    <input
                                        type='file'
                                        {...rest}
                                        name="img"
                                        ref={(e) => {
                                            ref(e);
                                            uploadRef.current = e;
                                        }}
                                        className='custom-file-input'
                                        id='val-img'
                                        accept="image/*"
                                        hidden
                                    />
                                    
                                    <ErrorMessage
                                        errors={errors}
                                        name='img'
                                        render={({ message }) => (
                                            <div className='text-danger fs-12'>
                                                {message}
                                            </div>
                                        )}
                                    />
                                </div>
                                
                                <FormInput
                                    label={'Name'}
                                    id={'val-name'}
                                    name={'name'}
                                    required={true}
                                    ErrorMessage={ErrorMessage}
                                    register={{
                                        ...register('name', {
                                            required: 'Chef name is required!',
                                        }),
                                    }}
                                    errors={errors}
                                />
                                
                                <div className='form-group mb-3'>
                                    <label
                                        className='text-black font-w500'
                                        htmlFor={'val-mob'}
                                    >
                                        Mobile Number
                                    </label>
                                    <div className='col-lg-12'>
                                        <Controller
                                            control={control}
                                            name='mobile'
                                            render={({
                                                field: { ref, ...field },
                                            }) => (
                                                <PhoneInput
                                                    {...field}
                                                    inputExtraProps={{
                                                        ref,
                                                        autoFocus: true,
                                                    }}
                                                    country={'sa'}
                                                    specialLabel=''
                                                />
                                            )}
                                        />
                                    </div>
                                </div>
                                
                                <FormInput
                                    label={'Email'}
                                    id={'val-email'}
                                    name={'email'}
                                    required={true}
                                    ErrorMessage={ErrorMessage}
                                    register={{
                                        ...register('email', {
                                            required: 'Email is required!',
                                            pattern: {
                                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                                message: 'Invalid email provided!',
                                            },
                                        }),
                                    }}
                                    errors={errors}
                                />
                                
                                <FormInput
                                    label={'Description'}
                                    id={'val-description'}
                                    name={'description'}
                                    ErrorMessage={ErrorMessage}
                                    register={{
                                        ...register('description'),
                                    }}
                                    errors={errors}
                                />
                                
                                <div className='custom-control custom-checkbox mb-3'>
                                    <input
                                        type='checkbox'
                                        defaultChecked
                                        className='custom-control-input'
                                        {...register('status')}
                                        id='val-status'
                                    />
                                    <label
                                        className='custom-control-label'
                                        htmlFor='val-status'
                                    >
                                        Active
                                    </label>
                                </div>
                                
                                <button className='btn btn-primary btn-block'>
                                    {chefId && chefDetails ? 'Update' : 'Add'}
                                </button>
                            </form>
                        </div>
                    </div>
                </>
            </Modal>
        )
    }
}

export default AddChef;